__turbopack_context__.v({
  "container": "FeatureHighlights-module__Ld8gNG__container",
  "feature": "FeatureHighlights-module__Ld8gNG__feature",
  "icon": "FeatureHighlights-module__Ld8gNG__icon",
});
